import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell, CheckCheck, ArrowDownToLine, BadgeCheck, XCircle, Banknote, UserPlus, Users, Settings2, Sparkles, CalendarClock } from "lucide-react";
import { api, relTime } from "../lib/api";
import { PageHeader, Spinner, EmptyState } from "../components/bits";

const ICONS = { contribution_due: CalendarClock, contribution_overdue: CalendarClock, payment_received: ArrowDownToLine, payment_verified: BadgeCheck, payment_rejected: XCircle, payout_scheduled: Banknote, payout_approved: Banknote, special_contribution_created: Sparkles, member_invited: UserPlus, new_member_joined: Users, rule_changed: Settings2 };

export default function Notifications() {
  const [items, setItems] = useState(null);
  const nav = useNavigate();
  const load = () => api.get("/notifications").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const readAll = async () => { await api.post("/notifications/read"); load(); };
  const open = async (n) => { await api.post("/notifications/read", [n.id]); if (n.link) nav(n.link.startsWith("/app") ? n.link : `/app${n.link}`); else load(); };
  if (!items) return <Spinner />;
  return (
    <div data-testid="notifications-page">
      <PageHeader title="Notifications" subtitle="Payments, approvals, reminders and group updates." action={<button className="btn-secondary" data-testid="mark-all-read-btn" onClick={readAll}><CheckCheck size={16} /> Mark all as read</button>} />
      {items.length === 0 ? <EmptyState icon={Bell} title="You're all caught up" /> : (
        <div className="card divide-y divide-nini-border">{items.map((n) => { const Icon = ICONS[n.type] || Bell; return (
          <button key={n.id} onClick={() => open(n)} data-testid={`notification-${n.id}`} className={`w-full flex items-start gap-4 p-4 md:p-5 text-left hover:bg-nini-surface/50 transition ${n.read ? "" : "bg-nini-mint/20"}`}>
            <span className={`h-10 w-10 rounded-xl inline-flex items-center justify-center shrink-0 ${n.read ? "bg-nini-surface text-nini-muted" : "bg-nini-mint text-nini-deep"}`}><Icon size={18} /></span>
            <span className="flex-1 min-w-0"><span className="block text-sm font-semibold text-nini-heading">{n.title}</span><span className="block text-sm text-nini-text">{n.message}</span><span className="block text-xs text-nini-muted mt-1">{relTime(n.created_at)}</span></span>
            {!n.read && <span className="h-2 w-2 rounded-full bg-nini-green mt-2" />}
          </button>
        ); })}</div>
      )}
    </div>
  );
}
